module.exports = __webpack_public_path__ + "img/formal_exam_fail.2ca100ee.png";